import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected } from '@redux/actions/menuAction';
// import moment from 'moment';
// import { DATE_FORMAT } from 'config';
import {
  getList,
  deleteOne,
  exportData,
} from 'api/facilityHazarWasteReportApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import Message from 'rc-message';
import { Row, Col } from 'reactstrap';
import Clearfix from 'components/elements/clearfix';
import { createForm } from 'rc-form';
import { get as _get } from 'lodash';
import PageLockHOC from 'hoc/pageLock';
import YearSelect from 'components/elements/select-year';
// import FacilitySelect from 'components/elements/select-facility';
import SelectQLCTNH from './SelectQLCTNH';
import { FIELDS } from 'containers/Coso/CosoView/ChiTietCosoPanel/constants';
import { COLOR } from 'config';
import { getLabelIndustrialArea } from 'utils/misc';
import { IS_ENTERPRISE } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityHazarWasteReport.view'])
class FacilityHazarWasteReportList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'facility.FacilityNameFull',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.HAZARDOUS_WASTE_REPORT.VIEW_WITH_ID + row._id}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      ...(!IS_ENTERPRISE && [
        {
          dataField: 'facility.organizationName',
          text: 'Tên doanh nghiệp',
          formatter: (cell, row) => {
            return <div>{cell}</div>;
          },
        },
      ]),
      {
        dataField: 'facility.industrialArea',
        text: getLabelIndustrialArea(),
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'facility.sector',
        text: 'Ngành/Nghề',
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: `facility.${FIELDS.reportHazardousWasteCode}`,
        text: 'Mã số QLCTNH',
        formatter: (cell, row) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'NamThucHienBaoCao',
        text: 'Năm báo cáo',
        formatter: (cell, row) => {
          return <div>{cell}</div>;
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      `${slug.HAZARDOUS_WASTE_REPORT.CREATE}?facilityId=${props.facilityId}`,
      'facilityHazarWasteReport',
      null,
      false,
      true
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
    };
  }

  handelSubmitSearch = (values) => {
    values.year = _get(values.year, 'value');
    values.emissionType = _get(values.emissionType, 'value');
    values.isHaveQLCTNH = _get(values.isHaveQLCTNH, 'value');
    values.NamThucHienBaoCao = _get(values.NamThucHienBaoCao, 'value');
    super.handelSubmitSearch(values);
  };

  renderSearchExpandContainer = () => {
    const { form } = this.props;
    return (
      <div>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <YearSelect
              fieldForm={{
                form,
                name: 'NamThucHienBaoCao',
              }}
            />
          </Col>
          <Col xs={4}>
            <SelectQLCTNH getFieldProps={form.getFieldProps('isHaveQLCTNH')} />
          </Col>
        </Row>
      </div>
    );
  };

  handelDelete = (_id) => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(_id);
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.fetData();
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(createForm()(FacilityHazarWasteReportList))
);



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportList/index.js